"use client";

import CarouselSection from "@/components/CarouselSection";
import { useTranslations } from "next-intl";

export default function FlightRouteBlogsClient({ blogPosts }) {
  const t = useTranslations("flight");
  const tCommon = useTranslations("common");

  return (
    <CarouselSection
      title={t("blogPosts")}
      description={t("blogPostsDescription")}
      linkText={tCommon("allView")}
      href="/blog/"
      preserveTrailingSlash={true}
      items={blogPosts}
      componentType="BlogCard"
      componentProps={{}}
    />
  );
}
